import React, { Component } from "react";
import AnimatedCounter from "./Counter";

class CounterSection extends Component {
  render() {
    const { counters = [], backgroundColor = "" } = this.props;

    return (
      <div
        style={{

          padding: "60px 20px",
        }}
      >
        <div className="container-short">
          <div className="row">
            {counters.map((counter, index) => (
              <div
                key={index}
                className={`col-md-${12 / counters.length}`}
                style={{ marginBottom: "20px" }}
              >
                <AnimatedCounter
                  endValue={counter.value}
                  label={counter.label}
                  duration={counter.duration || 2000}
                  easing={counter.easing || "easeOutQuart"}
                  animateOnView={counter.animateOnView !== false}
                  useCommas={counter.useCommas !== false}
                  fontSize={counter.fontSize}
                  labelSize={counter.labelSize}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CounterSection;
